import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, ToastmessageService, TranslationService } from '@prekog/common-ui';
import { FindDoctorRequest } from '../updatedoctor/finddoctorrequest';
import { FindDoctorResponse } from '../updatedoctor/finddoctorresponse';
import { AddJobTitleRequest } from './addjobtitlerequest';
import { Speciality } from './speciality';

@Component({
    selector: 'app-addjobtitle',
    templateUrl: './addjobtitle.component.html',
    styleUrls: ['./addjobtitle.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, RouterModule, MatIconModule, CommonModule]
})
export class AddjobtitleComponent implements OnInit {
    addJobTitleUrl = '/admin/add-job-title';

    doctorName = '';

    findDoctorUrl = '/regenero/find-doctor';

    originalRouterLink = 0;

    regeneroBaseUrl = '';

    routerLink = '';
    speciality: Speciality = {};

    specialityForm?: FormGroup;

    constructor(
        public _router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _toastMessageService: ToastmessageService,
        private _fb: FormBuilder,
        private _translateService: TranslationService
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;

        this.createSpecialityForm();
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            this.findDoctor();
        }
    }

    findDoctor() {
        const lastSegmentOfUrl = window.location.href.split('/').pop();
        this.routerLink = lastSegmentOfUrl as string;
        const findDoctorRequest: FindDoctorRequest = {
            routerLink: this.routerLink
        };

        this._apiRequestService
            .sendRequest<FindDoctorRequest, FindDoctorResponse>(this.regeneroBaseUrl, findDoctorRequest, true, this.findDoctorUrl)
            .subscribe((response) => {
                this.doctorName = response.doctor?.name!;
            });
    }

    createSpecialityForm() {
        this.specialityForm = this._fb.group({
            name: ['', [Validators.required]],
            jobTitle: ['', [Validators.required]]
        });
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    collectSpecialityData() {
        this.speciality = {
            name: this.specialityForm?.controls['name'].value as string | undefined,
            jobTitle: this.specialityForm?.controls['jobTitle'].value as string | undefined,
            isSpeciality: true
        };
    }

    addJobTitle() {
        this.collectSpecialityData();
        const addJobTitleRequest: AddJobTitleRequest = {
            speciality: this.speciality,
            doctorId: this.originalRouterLink
        };

        this._apiRequestService
            .sendRequest<AddJobTitleRequest, HttpResponse<any>>(this.regeneroBaseUrl, addJobTitleRequest, true, this.addJobTitleUrl, true)
            .subscribe(() => {
                this._router.navigateByUrl('/doctor/' + this.originalRouterLink);
            });
    }
}
